/**************************************************
 * Nombre:       Formulario_Asesoria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, MailOutline, PhoneAndroidOutlined} from "@mui/icons-material";

const Formulario_Asesoria = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'Dato Requerido'}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Num Celular'} dato={'celular'} {...props}
                                  requerido={'Dato Requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo electronico'} dato={'correo'} {...props}
                                  requerido={'Dato Requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={8} nombre={'Mensaje'} dato={'mensaje'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Asesoria